<template>
  <v-app id="sindec">
    <v-navigation-drawer v-model="drawer" app>
      <v-list>
        <v-list-group prepend-icon="mdi-calculator" :value="calculosOpen">
          <template v-slot:activator>
            <v-list-item-title>Cálculos</v-list-item-title>
          </template>
          <v-list-item :to="{ name: 'Calcular' }" link exact>
            <v-list-item-content>
              <v-list-item-title>Débitos em Apuração</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item :to="{ name: 'EncargosMoratorios' }" link exact>
            <v-list-item-content>
              <v-list-item-title>Encargos Moratórios</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item :to="{ name: 'Calcular3013' }" link>
            <v-list-item-content>
              <v-list-item-title>Passivos a Servidores</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
        <v-list-group prepend-icon="mdi-finance">
          <template v-slot:activator>
            <v-list-item-title>Tabelas</v-list-item-title>
          </template>
          <v-list-item :to="{ name: 'INPC' }" link>
            <v-list-item-content>
              <v-list-item-title>INPC</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item :to="{ name: 'IPCAE' }" link>
            <v-list-item-content>
              <v-list-item-title>IPCA</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item :to="{ name: 'Meta Selic' }" link>
            <v-list-item-content>
              <v-list-item-title>Meta Selic</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item :to="{ name: 'Selic' }" link>
            <v-list-item-content>
              <v-list-item-title>Selic Mensal</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item :to="{ name: 'TR' }" link>
            <v-list-item-content>
              <v-list-item-title>Taxa Referencial</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app color="#2f598b" dark>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
      <div class="d-flex align-center">
        <v-img
          alt="TCDF 60 Anos Logo"
          class="shrink mr-2"
          contain
          src="tcdf60.jpg"
          transition="scale-transition"
          width="50"
          position="top"
        />
      </div>
      <v-toolbar-title>
        SINDEC - Sistema de Índices e Indicadores Econômicos e de Atualização de
        Valores
      </v-toolbar-title>
    </v-app-bar>

    <v-content>
      <router-view></router-view>
    </v-content>
    <v-footer color="#2f598b" app>
      <span style="width: 100%" class="white--text text-center">&copy; Tribunal de Contas do Distrito Federal, 2020</span>
    </v-footer>
  </v-app>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data: () => ({
    drawer: true,
    calculosOpen: true
  }),
  methods: {
    ...mapActions(["clearCalculos"])
  },
  watch: {
    //Limpa lista de cálculos realizados se sair da página de cálculo da portaria 212 para página de cálculo da decisão 3013 e vice-versa
    $route(to, from) {
      if (
        this.$store.state.calculos.length > 0 &&
        ((to.path == "/" && from.path != "/") ||
          (to.path == "/3013" && from.path != "/3013"))
      ) {
        this.clearCalculos();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
a {
  text-decoration: none;
}
</style>
